export const numToNth = (num) => {
  const dd = num % 100;
  if (dd < 4 || dd > 20) {
    const d = dd % 10;
    if (d === 1) {
      return num + "st";
    }
    if (d === 2) {
      return num + "nd";
    }
    if (d === 3) {
      return num + "rd";
    }
  }
  return num + "th";
};
